import { fetchServer } from "@features/utils";
import { toast } from "sonner";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ProjectType } from "./type";

export const useProjects = () => {
  const { site } = useParams();

  const projects = useQuery({
    queryKey: ["projects", site],
    queryFn: async () =>
      await fetchServer<ProjectType[]>("/api/projects?site=" + site),
  });

  const upsert = useMutation({
    mutationFn: async (project: {
      id?: string;
      name: string;
      is_deleted?: boolean;
    }) => {
      try {
        const { id } = await fetchServer<{ id: string }>(
          project.id ? `/api/projects/${project.id}` : "/api/projects",
          { ...project, site }
        );
        return id;
      } catch (error) {
        toast.error("Failed to save project");
        return null;
      }
    },
    onSuccess: () => {
      projects.refetch();
    },
  });

  return {
    projects,
    upsert,
  };
};
